import {useSelector} from "react-redux";
import React from "react";

export const Text = () => {
    const app_lang = useSelector(state => state.app.app_lang)
    const current_page = useSelector(state => state.app.current_page);
    const aircategories = useSelector(state => state.app.aircategories)
    const current_category = useSelector(state => state.app.current_category)
    let text = null;

    const change_tag = (text_line) => {
        let new_text = '';
        if (text_line.indexOf('######') + 1 > 0) {
            new_text = text_line.replace('######', '<h6>') + '</h6>';
        } else {
            if (text_line.indexOf('#####') + 1 > 0) {
                new_text = text_line.replace('#####', '<h5>') + '</h5>';
            } else {
                if (text_line.indexOf('####') + 1 > 0) {
                    new_text = text_line.replace('####', '<h4>') + '</h4>';
                } else {
                    if (text_line.indexOf('###') + 1 > 0) {
                        new_text = text_line.replace('###', '<h3>') + '</h3>';
                    } else {
                        if (text_line.indexOf('##') + 1 > 0) {
                            new_text = text_line.replace('##', '<h2>') + '</h2>';
                        } else {
                            if (text_line.indexOf('#') + 1 > 0) {
                                new_text = text_line.replace('#', '<h1>') + '</h1>';
                            } else {
                                if (text_line.indexOf('<li') + 1 > 0 || text_line.indexOf('<ul') + 1 > 0 || text_line.indexOf('<ol') + 1 > 0) {
                                    new_text = text_line;
                                } else {
                                    new_text = '<p>' + text_line + '</p>';
                                }
                            }
                        }
                    }
                }
            }
        }

        return new_text;
    }
    if (app_lang === 'en'){
        return  null;
    }
    if (current_page !== null && current_page.Text !== undefined && current_page.Text.length > 0) {
        text = current_page.Text;
    } else {
        if (current_category === '') {
            aircategories.forEach((item) => {
                if (item.fields.locale && item.fields.locale === app_lang) {
                    if (item.fields.id === 0) {
                        if (item.fields.Text !== undefined && item.fields.Text.length > 0) {
                            text = item.fields.Text;
                        }
                    }
                }
            })
        } else {

            aircategories.forEach((item) => {
                if (item.fields.locale && item.fields.locale === app_lang) {
                    if (item.fields.slug && item.fields.slug === current_category) {
                        if (item.fields.Text !== undefined && item.fields.Text.length > 0) {
                            text = item.fields.Text;
                        }
                    }
                }
            })
        }
    }

    if (text !== null) {
        let text_arr = text.split('\n');
        if (text_arr.length > 0) {
            let new_text = '';
            for (let i = 0; i < text_arr.length; i++) {
                new_text += change_tag(text_arr[i]);
            }

            //let regexp = /\[+([a-zA-Z.!\s])+\]+(\()+([a-zA-Z.!\s])+(\))/gm;
            let regexp = /\[+([a-zA-Z0-9.!\s])+\]+\(+([a-zA-Z0-9.!?=&:\-/\s])+\)/gm;
            let matches = new_text.match(regexp);

            if (matches) {
                for (let i = 0; i < matches.length; i++) {
                    let temp = matches[i].split(']');
                    if (temp.length === 2) {
                        let name = temp[0].replace('[', '');
                        let link = temp[1].replace('(', '').replace(')', '');
                        new_text = new_text.replace(matches[i], '<a href="' + link + '" target="_blank">' + name + '</a>')
                    }
                }
            }
            let regexp2 = /\*\*+([a-zA-Z0-9.!?=&:\-/\s])+\*\*/gm;
            let matches2 = new_text.match(regexp2);
            if (matches2) {
                for (let i = 0; i < matches2.length; i++) {
                    let temp = matches2[i].replaceAll('**', '');
                    new_text = new_text.replace(matches2[i], '<strong>' + temp + '</strong>')
                }
            }
            let regexp3 = /\_+([a-zA-Z0-9.!?=&:\-/\s])+\_/gm;
            let matches3 = new_text.match(regexp3);
            if (matches3) {
                for (let i = 0; i < matches3.length; i++) {
                    let temp = matches3[i].replaceAll('_', '');
                    new_text = new_text.replace(matches3[i], '<italic>' + temp + '</italic>')
                }
            }

            return (<div className="text-block" dangerouslySetInnerHTML={{__html: new_text}}/>)
        }
    }
    return null;
}